/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-12 10:42:52
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-22 09:52:33
 */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../app/store'
import * as T from '../../services/chainSalesStatistics'

export const getChainSalesStatisticsList = createAsyncThunk<
  void,
  T.ChainSalesStatistiicsListParams,
  RootThunkApi
>('payment/getChainSalesStatisticsList', async (params, api) => {
  return sendAsync(T.chainSalesStatisticsList(params), api)
})


export const getChainSalesStatisticsExport = createAsyncThunk<
  void,
  T.ChainSalesStatistiicsListParams,
  RootThunkApi
>('payment/getChainSalesStatisticsExport', async (params, api) => {
  return sendAsync(T.chainSalesStatisticsExport(params), api)
})

